module.exports = __webpack_public_path__ + "static/carousel5.c8cb9f20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/carousel/carousel5.jpg
// module id = 709
// module chunks = 168707334958949